import script from "./esSelectHealthProDelegateModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./esSelectHealthProDelegateModal.vue?vue&type=script&setup=true&lang=ts"

import "./esSelectHealthProDelegateModal.vue?vue&type=style&index=0&id=b64e332c&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b64e332c"]])

export default __exports__